import { BaseEntity } from '@models';
import { Type } from 'class-transformer';
import { AssesmentQuestion } from './assesment-question.class';
import { AssesmentType } from './assesment-type.enum';

export class Assesment extends BaseEntity {
	name: string;
	assesmentType: AssesmentType;

	@Type(() => AssesmentQuestion)
	questions?: AssesmentQuestion[];
}
